import React from 'react';

import Root from './src/Root';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => <Root>{element}</Root>;
